import React from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
import { PropTypes } from "prop-types";
import {Translate, withLocalize} from "react-localize-redux";
import './style.css';

import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col
} from "reactstrap";
import * as actions from "../../store/actions/actions";
import {connect} from "react-redux";
import * as Roles from "../../store/actions/roles";
import italianSidebarTranslations from "../../translations/sidebar/it.sidebar.json";
import englishSidebarTranslations from "../../translations/sidebar/en.sidebar.json";

class Sidebar extends React.Component {
  state = {
    collapseOpen: false
  };
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    this.props.addTranslationForLanguage(italianSidebarTranslations, "it");
    this.props.addTranslationForLanguage(englishSidebarTranslations, "en");

  }
  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // creates the links that appear in the left menu / Sidebar
  createLinks = routes => {
    return routes.map((prop, key) => {
      if(prop.linkType === "main"){
        return (
            <NavItem key={key}>
              <NavLink
                  to={prop.path}
                  tag={NavLinkRRD}
                  onClick={this.closeCollapse}
                  activeClassName="active"
              >
                <i className={prop.icon} />
                {prop.name}
              </NavLink>
            </NavItem>
        );
      }
      return ""
    });
  };

  onUserMenuClick = () => {
    this.props.userPage()
  }

  onFileMenuClick = () => {
    this.props.filePage()
  }

  onCorporateMenuClick = () => {
    this.props.corporatePage()
  }

  onBankMenuClick = () => {
    this.props.bankPage()
  }

  onCampaignMenuClick = () => {
    this.props.campaignPage()
  }

  onReportMenuClick = () => {
    this.props.reportsPage()
  }

  onFaqMenuClick = () => {
    this.props.faqPage()
  }

  render() {

    let role=this.props.role;
    let reportFlag = this.props.report;
    let distinteFlag = this.props.distinte;

    let dashboard=
        <NavItem key="0">
          <NavLink
              to="/index"
              tag={NavLinkRRD}
              onClick={this.onUserMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-tv-2 text-primary" />
            <Translate id="sidebar.dashboard.menu"/>
          </NavLink>
        </NavItem>;

    let users = this.props.token === null || Roles.checkRole(role,Roles.MODULE_USER,Roles.OPERATION_VIEW, true) === false ? null :
        <NavItem key="1">
          <NavLink
              to="/user"
              tag={NavLinkRRD}
              onClick={this.onUserMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-single-02 text-yellow" />
            <Translate id="sidebar.user.menu"/>
          </NavLink>
        </NavItem>;


    let bank = this.props.token === null || Roles.checkRole(role,Roles.MODULE_BANK,Roles.OPERATION_VIEW, true) === false ? null :
        <NavItem key="3">
          <NavLink
              to="/bank"
              tag={NavLinkRRD}
              onClick={this.onBankMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-building text-red" />
            <Translate id="sidebar.bank.menu"/>
          </NavLink>
        </NavItem>;


    let corporate = this.props.token === null || Roles.checkRole(role,Roles.MODULE_CORPORATE,Roles.OPERATION_VIEW, true) === false ? null :
        <NavItem key="4">
          <NavLink
              to="/corporate"
              tag={NavLinkRRD}
              onClick={this.onCorporateMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-briefcase-24 text-blue" />
            <Translate id="sidebar.corporate.menu"/>
          </NavLink>
        </NavItem>;


    let campaign = this.props.token === null || Roles.checkRole(role,Roles.MODULE_CAMPAIGN,Roles.OPERATION_VIEW, true) === false ? null :
        <NavItem key="5">
          <NavLink
              to="/campaign"
              tag={NavLinkRRD}
              onClick={this.onCampaignMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-collection text-green" />
            <Translate id="sidebar.campaign.menu"/>
          </NavLink>
        </NavItem>;

    let report = this.props.token === null || Roles.checkRole(role, Roles.MODULE_REPORT, Roles.OPERATION_VIEW, reportFlag) === false ? null :
        <NavItem key="6">
          <NavLink
              to="/report"
              tag={NavLinkRRD}
              onClick={this.onReportMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-single-copy-04 text-blue" />
            <Translate id="sidebar.report.menu"/>
          </NavLink>
        </NavItem>;

      let files = this.props.token === null || Roles.checkRole(role, Roles.MODULE_FILE,Roles.OPERATION_VIEW, distinteFlag) === false ? null :
          <NavItem key="2">
              <NavLink
                  to="/file"
                  tag={NavLinkRRD}
                  onClick={this.onFileMenuClick}
                  activeClassName="active"
              >
                  <i className="ni ni-archive-2 text-indigo" />
                  <Translate id="sidebar.file.menu"/>
              </NavLink>
          </NavItem>;

    let faq = this.props.token === null ? null :
        <NavItem key="7">
          <NavLink
              to="/faq"
              tag={NavLinkRRD}
              onClick={this.onFaqMenuClick}
              activeClassName="active"
          >
            <i className="ni ni-chat-round text-blue" />
            <Translate id="sidebar.faq.menu"/>
          </NavLink>
        </NavItem>;



    const { logo } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    return (
        <Navbar
            className="navbar-vertical fixed-left navbar-light bg-white"
            expand="md"
            id="sidenav-main"
        >
          <Container fluid>
            <button
                className="navbar-toggler"
                type="button"
                onClick={this.toggleCollapse}
            >
              <span className="navbar-toggler-icon" />
            </button>
            {logo ? (
                <NavbarBrand className="pt-0" {...navbarBrandProps}>
                  <img
                      alt={logo.imgAlt}
                      className="navbar-brand-img"
                      src={logo.imgSrc}
                  />
                </NavbarBrand>
            ) : null}
            <Collapse navbar isOpen={this.state.collapseOpen}>
              <div className="navbar-collapse-header d-md-none">
                <Row>
                  {logo ? (
                      <Col className="collapse-brand" xs="6">
                        {logo.innerLink ? (
                            <Link to={logo.innerLink}>
                              <img alt={logo.imgAlt} src={logo.imgSrc} />
                            </Link>
                        ) : (
                            <a href={logo.outterLink}>
                              <img alt={logo.imgAlt} src={logo.imgSrc} />
                            </a>
                        )}
                      </Col>
                  ) : null}
                  <Col className="collapse-close" xs="6">
                    <button
                        className="navbar-toggler"
                        type="button"
                        onClick={this.toggleCollapse}
                    >
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>
              </div>
              <Nav navbar>
                {dashboard}
                {users}
                {files}
                {bank}
                {corporate}
                {campaign}
                {report}
                {faq}
              </Nav>

              <hr className="my-3" />

            </Collapse>
            <div className="containerRelative">
              <div className="logo">
                <img style={{height:"30px",width:"80px"}} alt="" src={require("../../assets/img/brand/poweredbyPayDo.png")} />
              </div>
            </div>
          </Container>
        </Navbar>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

const mapStateToProps = state => {
  return {
    token : state.authentication.authenticatedUser.token,
    role : state.authentication.authenticatedUser.role,
    report: state.authentication.authenticatedUser.report,
    distinte:  state.authentication.authenticatedUser.distinte
  };
}

const mapDispatchToProps = dispatch => {
  return {
    userPage: () => dispatch({ type: actions.USER_PAGE_MENU_REQUEST }),
    homePage: () => dispatch({ type: actions.HOME_PAGE_MENU_REQUEST }),
    filePage: () => dispatch({ type: actions.FILE_PAGE_MENU_REQUEST }),
    bankPage: () => dispatch({ type: actions.BANK_PAGE_MENU_REQUEST }),
    faqPage: () => dispatch({ type: actions.FAQ_PAGE_MENU_REQUEST }),
    corporatePage: () => dispatch({ type: actions.CORPORATE_PAGE_MENU_REQUEST }),
    campaignPage: () => dispatch({ type: actions.CAMPAIGN_PAGE_MENU_REQUEST }),
    reportsPage: () => dispatch({type:actions.REPORT_PAGE_MENU_REQUEST}),
  }
};

export default withLocalize(connect(mapStateToProps, mapDispatchToProps)(Sidebar));
